import { DefaultTemplate, COR, CORES_SIM_NAO, CORES_PRIORIDADE } from './types';

// ============================================================
// TI / TECNOLOGIA — Service Desk, Acessos, Desenvolvimento (Sprint),
// Mudanças (Change), Incidentes
// ============================================================

const serviceDesk: DefaultTemplate = {
  id: 'tpl_chamados_ti',
  name: 'Service Desk (Chamados)',
  descricao: 'Central de chamados com triagem por prioridade, SLA por criticidade, fila em atendimento, escalonamento para nível 2 e validação do usuário antes de fechar. O clássico N1/N2 organizado.',
  categoria: 'ti',
  icone: '🖥️',
  etiquetas: [
    { nome: 'Parou a operação', cor: COR.vermelho },
    { nome: 'Recorrente', cor: COR.amarelo },
    { nome: 'Melhoria', cor: COR.azul },
    { nome: 'Hardware', cor: COR.roxo },
  ],
  etapas: [
    {
      id: 'ti_e1', nome: 'Aberto',
      tempoMaximoHoras: 2,
      camposVisiveisNoCard: ['ti_c1', 'ti_c4', 'ti_c5'],
      permiteMoverPara: ['ti_e2'],
      campos: [
        { id: 'ti_c1', nome: 'Título do Chamado', tipo: 'texto', obrigatorio: true, usarComoTitulo: true },
        { id: 'ti_c2', nome: 'Solicitante', tipo: 'texto', obrigatorio: true },
        { id: 'ti_c3', nome: 'Setor', tipo: 'lista', obrigatorio: true, opcoes: ['Administrativo', 'Comercial', 'Operações', 'TI', 'Marketing', 'RH', 'Financeiro'] },
        { id: 'ti_c4', nome: 'Categoria', tipo: 'lista', obrigatorio: true, opcoes: ['Hardware', 'Software', 'Rede / Internet', 'Acesso / Senha', 'E-mail', 'Impressora', 'Sistema ERP', 'Telefonia', 'Outro'], coresOpcoes: { 'Hardware': COR.roxo, 'Rede / Internet': COR.vermelho, 'Sistema ERP': COR.azul } },
        { id: 'ti_c5', nome: 'Prioridade', tipo: 'lista', obrigatorio: true, opcoes: ['Baixa', 'Média', 'Alta', 'Urgente'], coresOpcoes: CORES_PRIORIDADE },
        { id: 'ti_c6', nome: 'Descrição do Problema', tipo: 'texto_longo', obrigatorio: true },
        { id: 'ti_c7', nome: 'Print / Evidência', tipo: 'anexo', obrigatorio: false },
        { id: 'ti_c8', nome: 'Impede o trabalho?', tipo: 'lista', obrigatorio: true, opcoes: ['Sim', 'Não'], coresOpcoes: CORES_SIM_NAO },
      ],
    },
    {
      id: 'ti_e2', nome: 'Triagem',
      tempoMaximoHoras: 4,
      camposVisiveisNoCard: ['ti_c1', 'ti_c5', 'ti_c9'],
      permiteMoverPara: ['ti_e3', 'ti_e6', 'ti_e7'],
      permiteCriarCards: false,
      campos: [
        { id: 'ti_c9', nome: 'Tipo de Chamado', tipo: 'lista', obrigatorio: true, opcoes: ['Incidente (algo quebrou)', 'Requisição (algo novo)', 'Dúvida', 'Melhoria'], coresOpcoes: { 'Incidente (algo quebrou)': COR.vermelho, 'Requisição (algo novo)': COR.azul, 'Melhoria': COR.ciano } },
        { id: 'ti_c10', nome: 'Nível de Atendimento', tipo: 'lista', obrigatorio: true, opcoes: ['N1 - Suporte', 'N2 - Especialista', 'N3 - Fornecedor'], coresOpcoes: { 'N1 - Suporte': COR.verde, 'N2 - Especialista': COR.amarelo, 'N3 - Fornecedor': COR.vermelho } },
        { id: 'ti_c11', nome: 'Técnico Responsável', tipo: 'texto', obrigatorio: false },
        { id: 'ti_c12', nome: 'Análise Inicial', tipo: 'texto_longo', obrigatorio: false },
      ],
    },
    {
      id: 'ti_e3', nome: 'Em Atendimento',
      tempoMaximoHoras: 8,
      camposVisiveisNoCard: ['ti_c1', 'ti_c5', 'ti_c11'],
      permiteMoverPara: ['ti_e4', 'ti_e5', 'ti_e6'],
      permiteCriarCards: false,
      campos: [
        { id: 'ti_c13', nome: 'Diagnóstico', tipo: 'texto_longo', obrigatorio: false },
        { id: 'ti_c14', nome: 'Ações Realizadas', tipo: 'texto_longo', obrigatorio: false },
        { id: 'ti_c15', nome: 'Tempo Gasto (horas)', tipo: 'numero', obrigatorio: false },
        { id: 'ti_c16', nome: 'Precisa de peça/compra?', tipo: 'lista', obrigatorio: false, opcoes: ['Sim', 'Não'], coresOpcoes: CORES_SIM_NAO },
      ],
    },
    {
      id: 'ti_e4', nome: 'Aguardando Usuário',
      tempoMaximoHoras: 48,
      camposVisiveisNoCard: ['ti_c1', 'ti_c17'],
      permiteMoverPara: ['ti_e3', 'ti_e6'],
      permiteCriarCards: false,
      campos: [
        { id: 'ti_c17', nome: 'O que está pendente', tipo: 'texto_longo', obrigatorio: true },
        { id: 'ti_c18', nome: 'Usuário respondeu?', tipo: 'lista', obrigatorio: false, opcoes: ['Sim', 'Não'], coresOpcoes: CORES_SIM_NAO },
      ],
    },
    {
      id: 'ti_e5', nome: 'Escalado para N2/N3',
      tempoMaximoHoras: 24,
      camposVisiveisNoCard: ['ti_c1', 'ti_c19'],
      permiteMoverPara: ['ti_e3', 'ti_e6'],
      permiteCriarCards: false,
      campos: [
        { id: 'ti_c19', nome: 'Escalado para', tipo: 'texto', obrigatorio: true },
        { id: 'ti_c20', nome: 'Motivo do Escalonamento', tipo: 'texto_longo', obrigatorio: true },
        { id: 'ti_c21', nome: 'Protocolo do Fornecedor', tipo: 'texto', obrigatorio: false },
        { id: 'ti_c22', nome: 'Previsão de Retorno', tipo: 'data', obrigatorio: false },
      ],
    },
    {
      id: 'ti_e6', nome: 'Resolvido - Validar',
      tempoMaximoHoras: 24,
      camposVisiveisNoCard: ['ti_c1', 'ti_c24'],
      permiteMoverPara: ['ti_e7', 'ti_e3'],
      permiteCriarCards: false,
      campos: [
        { id: 'ti_c23', nome: 'Solução Aplicada', tipo: 'texto_longo', obrigatorio: true },
        { id: 'ti_c24', nome: 'Usuário confirmou a solução?', tipo: 'lista', obrigatorio: true, opcoes: ['Sim', 'Não'], coresOpcoes: CORES_SIM_NAO },
        { id: 'ti_c25', nome: 'Virou artigo na base de conhecimento?', tipo: 'lista', obrigatorio: false, opcoes: ['Sim', 'Não'], coresOpcoes: CORES_SIM_NAO },
      ],
    },
    {
      id: 'ti_e7', nome: 'Fechado',
      camposVisiveisNoCard: ['ti_c1', 'ti_c26'],
      permiteCriarCards: false,
      campos: [
        { id: 'ti_c26', nome: 'Satisfação (0-10)', tipo: 'numero', obrigatorio: false, valorMinimo: 0, valorMaximo: 10 },
        { id: 'ti_c27', nome: 'Comentário do Usuário', tipo: 'texto_longo', obrigatorio: false },
        { id: 'ti_c28', nome: 'Causa Raiz', tipo: 'lista', obrigatorio: false, opcoes: ['Falha de equipamento', 'Erro de configuração', 'Erro do usuário', 'Falta de treinamento', 'Bug do sistema', 'Falha do fornecedor'] },
      ],
    },
  ],
  automacoes: [
    {
      tipo: 'mover',
      nome: 'Usuário respondeu volta para atendimento',
      etapaOrigemId: 'ti_e4',
      condicao: { campoId: 'ti_c18', operador: 'igual', valor: 'Sim' },
      etapaDestinoId: 'ti_e3',
    },
    {
      tipo: 'mover',
      nome: 'Usuário confirmou fecha o chamado',
      etapaOrigemId: 'ti_e6',
      condicao: { campoId: 'ti_c24', operador: 'igual', valor: 'Sim' },
      etapaDestinoId: 'ti_e7',
      etapaDestinoSenaoId: 'ti_e3',
    },
    {
      tipo: 'exibir_ocultar',
      nome: 'Perguntar sobre compra quando faltar peça',
      etapaOrigemId: 'ti_e3',
      condicao: { campoId: 'ti_c16', operador: 'igual', valor: 'Sim' },
      camposAfetadosIds: ['ti_c14'],
    },
  ],
  cards: [
    { id: 'ti_card1', titulo: 'Internet caiu no setor comercial', etapaId: 'ti_e3', etiquetas: ['Parou a operação'], valores: { ti_c1: 'Internet caiu no setor comercial', ti_c3: 'Comercial', ti_c4: 'Rede / Internet', ti_c5: 'Urgente', ti_c8: 'Sim', ti_c9: 'Incidente (algo quebrou)', ti_c10: 'N1 - Suporte' } },
    { id: 'ti_card2', titulo: 'Notebook não liga', etapaId: 'ti_e5', etiquetas: ['Hardware'], valores: { ti_c1: 'Notebook não liga', ti_c3: 'Financeiro', ti_c4: 'Hardware', ti_c5: 'Alta', ti_c8: 'Sim', ti_c10: 'N3 - Fornecedor', ti_c19: 'Assistência Dell' } },
    { id: 'ti_card3', titulo: 'Reset de senha do ERP', etapaId: 'ti_e7', valores: { ti_c1: 'Reset de senha do ERP', ti_c3: 'Operações', ti_c4: 'Acesso / Senha', ti_c5: 'Média', ti_c26: 10 } },
    { id: 'ti_card4', titulo: 'Impressora com atolamento constante', etapaId: 'ti_e2', etiquetas: ['Recorrente'], valores: { ti_c1: 'Impressora com atolamento constante', ti_c3: 'Administrativo', ti_c4: 'Impressora', ti_c5: 'Média', ti_c8: 'Não' } },
    { id: 'ti_card5', titulo: 'Adicionar campo no relatório de vendas', etapaId: 'ti_e1', etiquetas: ['Melhoria'], valores: { ti_c1: 'Adicionar campo no relatório de vendas', ti_c3: 'Comercial', ti_c4: 'Sistema ERP', ti_c5: 'Baixa', ti_c8: 'Não' } },
    { id: 'ti_card6', titulo: 'E-mails não chegam do domínio externo', etapaId: 'ti_e6', valores: { ti_c1: 'E-mails não chegam do domínio externo', ti_c3: 'Marketing', ti_c4: 'E-mail', ti_c5: 'Alta', ti_c23: 'Ajustado registro SPF do domínio.' } },
    { id: 'ti_card7', titulo: 'Solicitação de segundo monitor', etapaId: 'ti_e4', valores: { ti_c1: 'Solicitação de segundo monitor', ti_c3: 'TI', ti_c4: 'Hardware', ti_c5: 'Baixa', ti_c17: 'Aguardando aprovação do gestor da área.' } },
  ],
  tour: [
    '🖥️ Service Desk N1/N2/N3 com SLA de verdade em cada etapa.',
    '1️⃣ "Aberto": SLA de 2h só para alguém olhar o chamado.',
    '2️⃣ "Triagem": classifica em incidente/requisição e define o nível de atendimento.',
    '3️⃣ "Em Atendimento": diagnóstico, ações e tempo gasto.',
    '4️⃣ Travou por falta de resposta? "Aguardando Usuário" — e o relógio conta separado.',
    '5️⃣ "Escalado": fornecedor com protocolo e previsão de retorno.',
    '6️⃣ "Resolvido - Validar": o usuário confirma. Não resolveu? volta para atendimento sozinho.',
    '📊 Preencha a "Causa Raiz" no fechamento e descubra o que mais consome sua TI.',
  ],
  etapasDicas: [
    { quemFaz: 'Qualquer colaborador', objetivo: 'Abrir o chamado com evidência — print vale mais que três parágrafos.', ondeConfigurar: 'Configuração da Etapa > Campos obrigatórios' },
    { quemFaz: 'Analista N1', objetivo: 'Classificar e direcionar rápido — triagem boa reduz retrabalho.', ondeConfigurar: 'Configuração da Etapa > SLA' },
    { quemFaz: 'Técnico responsável', objetivo: 'Resolver e documentar o que foi feito para a próxima vez ser mais rápida.', automacoes: ['Já configurado: sinalizar necessidade de peça destaca as ações realizadas'], conexoes: ['Ligue a Requisição de Compra quando precisar comprar peça ou licença'], ondeConfigurar: 'Conexões entre Fluxos > Requisição de Compra' },
    { quemFaz: 'Técnico', objetivo: 'Parar o relógio quando a bola está com o usuário — SLA justo.', automacoes: ['Já configurado: usuário respondeu devolve o card para atendimento'], ondeConfigurar: 'Automações > "Usuário respondeu volta para atendimento"' },
    { quemFaz: 'Analista N2 / Fornecedor', objetivo: 'Registrar protocolo externo e previsão — cobrança com data.', ondeConfigurar: 'Configuração da Etapa > Campos' },
    { quemFaz: 'Usuário solicitante', objetivo: 'Confirmar que resolveu de verdade antes de fechar.', automacoes: ['Já configurado: confirmou fecha; não confirmou volta para atendimento'], ondeConfigurar: 'Automações > "Usuário confirmou fecha o chamado"' },
    { quemFaz: 'Coordenador de TI', objetivo: 'Medir satisfação e causa raiz — base para atacar o problema, não o sintoma.', ondeConfigurar: 'Dashboard > Tempo médio por etapa' },
  ],
};

const gestaoAcessos: DefaultTemplate = {
  id: 'tpl_gestao_acessos',
  name: 'Gestão de Acessos',
  descricao: 'Concessão, alteração e revogação de acessos a sistemas com aprovação do gestor, registro do que foi liberado e revisão periódica. Auditoria de segurança pronta para ISO e LGPD.',
  categoria: 'ti',
  icone: '🔐',
  etiquetas: [
    { nome: 'Acesso privilegiado', cor: COR.vermelho },
    { nome: 'Desligamento', cor: COR.amarelo },
    { nome: 'Revisão periódica', cor: COR.azul },
  ],
  etapas: [
    {
      id: 'ga_e1', nome: 'Solicitação',
      tempoMaximoHoras: 4,
      camposVisiveisNoCard: ['ga_c1', 'ga_c3', 'ga_c4'],
      permiteMoverPara: ['ga_e2'],
      campos: [
        { id: 'ga_c1', nome: 'Colaborador', tipo: 'texto', obrigatorio: true, usarComoTitulo: true },
        { id: 'ga_c2', nome: 'Setor', tipo: 'lista', obrigatorio: true, opcoes: ['Administrativo', 'Comercial', 'Operações', 'TI', 'Marketing', 'RH', 'Financeiro'] },
        { id: 'ga_c3', nome: 'Tipo de Solicitação', tipo: 'lista', obrigatorio: true, opcoes: ['Conceder acesso', 'Alterar permissão', 'Revogar acesso', 'Revisão periódica'], coresOpcoes: { 'Conceder acesso': COR.verde, 'Revogar acesso': COR.vermelho, 'Alterar permissão': COR.amarelo, 'Revisão periódica': COR.azul } },
        { id: 'ga_c4', nome: 'Sistemas Envolvidos', tipo: 'checkbox_multi', obrigatorio: true, opcoes: ['E-mail corporativo', 'ERP', 'CRM', 'Financeiro', 'RH / Folha', 'VPN', 'Servidor de arquivos', 'Banco de dados', 'Ferramentas de nuvem'] },
        { id: 'ga_c5', nome: 'Nível de Permissão', tipo: 'lista', obrigatorio: true, opcoes: ['Somente leitura', 'Operador', 'Aprovador', 'Administrador'], coresOpcoes: { 'Administrador': COR.vermelho, 'Aprovador': COR.amarelo, 'Somente leitura': COR.verde } },
        { id: 'ga_c6', nome: 'Justificativa', tipo: 'texto_longo', obrigatorio: true },
        { id: 'ga_c7', nome: 'Acesso temporário?', tipo: 'lista', obrigatorio: false, opcoes: ['Sim', 'Não'], coresOpcoes: CORES_SIM_NAO },
        { id: 'ga_c8', nome: 'Válido até', tipo: 'data_vencimento', obrigatorio: false },
      ],
    },
    {
      id: 'ga_e2', nome: 'Aprovação do Gestor',
      tempoMaximoHoras: 24,
      camposVisiveisNoCard: ['ga_c1', 'ga_c5', 'ga_c9'],
      permiteMoverPara: ['ga_e3', 'ga_e6'],
      permiteCriarCards: false,
      campos: [
        { id: 'ga_c9', nome: 'Aprovado pelo gestor?', tipo: 'lista', obrigatorio: true, opcoes: ['Sim', 'Não'], coresOpcoes: CORES_SIM_NAO },
        { id: 'ga_c10', nome: 'Observação', tipo: 'texto_longo', obrigatorio: false },
      ],
    },
    {
      id: 'ga_e3', nome: 'Aprovação de Segurança',
      tempoMaximoHoras: 24,
      camposVisiveisNoCard: ['ga_c1', 'ga_c11'],
      permiteMoverPara: ['ga_e4', 'ga_e6'],
      permiteCriarCards: false,
      campos: [
        { id: 'ga_c11', nome: 'Aprovado pela Segurança/TI?', tipo: 'lista', obrigatorio: true, opcoes: ['Sim', 'Não'], coresOpcoes: CORES_SIM_NAO },
        { id: 'ga_c12', nome: 'Risco Avaliado', tipo: 'lista', obrigatorio: false, opcoes: ['Baixo', 'Médio', 'Alto'], coresOpcoes: { 'Baixo': COR.verde, 'Médio': COR.amarelo, 'Alto': COR.vermelho } },
        { id: 'ga_c13', nome: 'Segregação de função respeitada?', tipo: 'lista', obrigatorio: false, opcoes: ['Sim', 'Não'], coresOpcoes: CORES_SIM_NAO },
      ],
    },
    {
      id: 'ga_e4', nome: 'Execução',
      tempoMaximoHoras: 8,
      camposVisiveisNoCard: ['ga_c1', 'ga_c4'],
      permiteMoverPara: ['ga_e5'],
      permiteCriarCards: false,
      campos: [
        { id: 'ga_c14', nome: 'Executado por', tipo: 'texto', obrigatorio: true },
        { id: 'ga_c15', nome: 'Data da Execução', tipo: 'data', obrigatorio: true },
        { id: 'ga_c16', nome: 'Detalhes do que foi feito', tipo: 'texto_longo', obrigatorio: true },
        { id: 'ga_c17', nome: 'Evidência (print/log)', tipo: 'anexo', obrigatorio: false },
        { id: 'ga_c18', nome: 'Usuário notificado?', tipo: 'lista', obrigatorio: false, opcoes: ['Sim', 'Não'], coresOpcoes: CORES_SIM_NAO },
      ],
    },
    {
      id: 'ga_e5', nome: 'Concluído',
      camposVisiveisNoCard: ['ga_c1', 'ga_c3'],
      permiteCriarCards: false,
      campos: [
        { id: 'ga_c19', nome: 'Registrado na matriz de acessos?', tipo: 'lista', obrigatorio: false, opcoes: ['Sim', 'Não'], coresOpcoes: CORES_SIM_NAO },
      ],
    },
    {
      id: 'ga_e6', nome: 'Negado',
      camposVisiveisNoCard: ['ga_c1', 'ga_c20'],
      permiteMoverPara: ['ga_e1'],
      permiteCriarCards: false,
      campos: [
        { id: 'ga_c20', nome: 'Motivo da Negativa', tipo: 'texto_longo', obrigatorio: true },
      ],
    },
  ],
  automacoes: [
    {
      tipo: 'mover',
      nome: 'Gestor aprovou vai para análise de segurança',
      etapaOrigemId: 'ga_e2',
      condicao: { campoId: 'ga_c9', operador: 'igual', valor: 'Sim' },
      etapaDestinoId: 'ga_e3',
      etapaDestinoSenaoId: 'ga_e6',
    },
    {
      tipo: 'mover',
      nome: 'Segurança aprovou libera a execução',
      etapaOrigemId: 'ga_e3',
      condicao: { campoId: 'ga_c11', operador: 'igual', valor: 'Sim' },
      etapaDestinoId: 'ga_e4',
      etapaDestinoSenaoId: 'ga_e6',
    },
    {
      tipo: 'mover',
      nome: 'Execução registrada conclui a solicitação',
      etapaOrigemId: 'ga_e4',
      condicao: { campoId: 'ga_c16', operador: 'preenchido' },
      etapaDestinoId: 'ga_e5',
    },
    {
      tipo: 'exibir_ocultar',
      nome: 'Mostrar validade quando o acesso for temporário',
      etapaOrigemId: 'ga_e1',
      condicao: { campoId: 'ga_c7', operador: 'igual', valor: 'Sim' },
      camposAfetadosIds: ['ga_c8'],
    },
  ],
  cards: [
    { id: 'ga_card1', titulo: 'Larissa Campos', etapaId: 'ga_e4', valores: { ga_c1: 'Larissa Campos', ga_c2: 'TI', ga_c3: 'Conceder acesso', ga_c5: 'Operador' } },
    { id: 'ga_card2', titulo: 'Carlos Menezes', etapaId: 'ga_e5', etiquetas: ['Desligamento'], valores: { ga_c1: 'Carlos Menezes', ga_c2: 'Comercial', ga_c3: 'Revogar acesso', ga_c5: 'Operador' } },
    { id: 'ga_card3', titulo: 'Pedro Lima', etapaId: 'ga_e3', etiquetas: ['Acesso privilegiado'], valores: { ga_c1: 'Pedro Lima', ga_c2: 'TI', ga_c3: 'Alterar permissão', ga_c5: 'Administrador', ga_c12: 'Alto' } },
    { id: 'ga_card4', titulo: 'Revisão trimestral - Financeiro', etapaId: 'ga_e2', etiquetas: ['Revisão periódica'], valores: { ga_c1: 'Revisão trimestral - Financeiro', ga_c2: 'Financeiro', ga_c3: 'Revisão periódica', ga_c5: 'Somente leitura' } },
    { id: 'ga_card5', titulo: 'Estagiário - acesso VPN', etapaId: 'ga_e6', valores: { ga_c1: 'Thiago Nunes', ga_c2: 'TI', ga_c3: 'Conceder acesso', ga_c5: 'Operador', ga_c20: 'Estagiário não tem perfil para VPN conforme política de segurança.' } },
  ],
  tour: [
    '🔐 Quem tem acesso a quê — com aprovação dupla e evidência.',
    '1️⃣ "Solicitação": sistema, nível de permissão e justificativa. Temporário? o campo de validade aparece.',
    '2️⃣ "Aprovação do Gestor": o gestor da área autoriza.',
    '3️⃣ "Aprovação de Segurança": TI avalia risco e segregação de função.',
    '4️⃣ "Execução": quem fez, quando e com print de evidência — auditoria feliz.',
    '5️⃣ "Concluído" com registro na matriz de acessos.',
    '🛡️ Negado em qualquer ponto vai para "Negado" com motivo — nada some.',
  ],
  etapasDicas: [
    { quemFaz: 'Gestor ou colaborador', objetivo: 'Pedir acesso com justificativa e prazo — acesso eterno é risco eterno.', automacoes: ['Já configurado: campo de validade aparece só em acesso temporário'], ondeConfigurar: 'Automações > "Mostrar validade quando o acesso for temporário"' },
    { quemFaz: 'Gestor da área', objetivo: 'Confirmar que a pessoa precisa mesmo daquele nível de permissão.', automacoes: ['Já configurado: aprovado segue, negado registra o motivo'], ondeConfigurar: 'Automações > "Gestor aprovou vai para análise de segurança"' },
    { quemFaz: 'Segurança da Informação / TI', objetivo: 'Avaliar risco e evitar acúmulo indevido de funções (segregação).', ondeConfigurar: 'Configuração da Etapa > Campos' },
    { quemFaz: 'Analista de TI', objetivo: 'Executar e registrar evidência — sem evidência, não aconteceu.', automacoes: ['Já configurado: detalhes preenchidos concluem a solicitação'], conexoes: ['Receba deste fluxo os cards de Admissão e Desligamento automaticamente'], ondeConfigurar: 'Conexões entre Fluxos > Admissão / Desligamento' },
    { quemFaz: 'TI', objetivo: 'Manter a matriz de acessos atualizada para a próxima auditoria.', ondeConfigurar: 'Configuração da Etapa > Campos' },
    { quemFaz: 'Solicitante', objetivo: 'Entender a negativa e, se for o caso, refazer com outro nível.', ondeConfigurar: 'Configuração da Etapa > Transições permitidas' },
  ],
};

const desenvolvimento: DefaultTemplate = {
  id: 'tpl_desenvolvimento_sprint',
  name: 'Desenvolvimento (Sprint)',
  descricao: 'Board de desenvolvimento com backlog priorizado, refinamento, WIP controlado, code review, QA e deploy. Feito para squads que trabalham em sprint e precisam de rastreabilidade.',
  categoria: 'ti',
  icone: '⌨️',
  etiquetas: [
    { nome: 'Bug', cor: COR.vermelho },
    { nome: 'Feature', cor: COR.azul },
    { nome: 'Débito técnico', cor: COR.amarelo },
    { nome: 'Bloqueado', cor: COR.roxo },
  ],
  etapas: [
    {
      id: 'dv_e1', nome: 'Backlog',
      camposVisiveisNoCard: ['dv_c1', 'dv_c3', 'dv_c4'],
      permiteMoverPara: ['dv_e2'],
      campos: [
        { id: 'dv_c1', nome: 'Título', tipo: 'texto', obrigatorio: true, usarComoTitulo: true },
        { id: 'dv_c2', nome: 'Descrição / User Story', tipo: 'texto_longo', obrigatorio: true },
        { id: 'dv_c3', nome: 'Tipo', tipo: 'lista', obrigatorio: true, opcoes: ['Feature', 'Bug', 'Débito técnico', 'Spike / Pesquisa', 'Melhoria'], coresOpcoes: { 'Bug': COR.vermelho, 'Feature': COR.azul, 'Débito técnico': COR.amarelo } },
        { id: 'dv_c4', nome: 'Prioridade', tipo: 'lista', obrigatorio: true, opcoes: ['Baixa', 'Média', 'Alta', 'Urgente'], coresOpcoes: CORES_PRIORIDADE },
        { id: 'dv_c5', nome: 'Solicitante / Área', tipo: 'texto', obrigatorio: false },
        { id: 'dv_c6', nome: 'Valor para o Negócio', tipo: 'texto_longo', obrigatorio: false },
      ],
    },
    {
      id: 'dv_e2', nome: 'Refinamento',
      tempoMaximoHoras: 72,
      camposVisiveisNoCard: ['dv_c1', 'dv_c8'],
      permiteMoverPara: ['dv_e3'],
      permiteCriarCards: false,
      campos: [
        { id: 'dv_c7', nome: 'Critérios de Aceite', tipo: 'texto_longo', obrigatorio: true },
        { id: 'dv_c8', nome: 'Estimativa (pontos)', tipo: 'lista', obrigatorio: true, opcoes: ['1', '2', '3', '5', '8', '13', '21'] },
        { id: 'dv_c9', nome: 'Dependências', tipo: 'texto_longo', obrigatorio: false },
        { id: 'dv_c10', nome: 'Protótipo / Design', tipo: 'anexo', obrigatorio: false },
        { id: 'dv_c11', nome: 'Refinado?', tipo: 'lista', obrigatorio: true, opcoes: ['Sim', 'Não'], coresOpcoes: CORES_SIM_NAO },
      ],
    },
    {
      id: 'dv_e3', nome: 'Sprint - A Fazer',
      camposVisiveisNoCard: ['dv_c1', 'dv_c8', 'dv_c12'],
      permiteMoverPara: ['dv_e4'],
      permiteCriarCards: false,
      campos: [
        { id: 'dv_c12', nome: 'Sprint', tipo: 'texto', obrigatorio: false },
        { id: 'dv_c13', nome: 'Desenvolvedor', tipo: 'texto', obrigatorio: false },
      ],
    },
    {
      id: 'dv_e4', nome: 'Em Desenvolvimento',
      tempoMaximoHoras: 72,
      camposVisiveisNoCard: ['dv_c1', 'dv_c13', 'dv_c14'],
      permiteMoverPara: ['dv_e5', 'dv_e8'],
      permiteCriarCards: false,
      campos: [
        { id: 'dv_c14', nome: 'Progresso', tipo: 'progresso', obrigatorio: false },
        { id: 'dv_c15', nome: 'Branch', tipo: 'texto', obrigatorio: false },
        { id: 'dv_c16', nome: 'Notas Técnicas', tipo: 'texto_longo', obrigatorio: false },
        { id: 'dv_c17', nome: 'Está bloqueado?', tipo: 'lista', obrigatorio: false, opcoes: ['Sim', 'Não'], coresOpcoes: CORES_SIM_NAO },
      ],
    },
    {
      id: 'dv_e5', nome: 'Code Review',
      tempoMaximoHoras: 24,
      camposVisiveisNoCard: ['dv_c1', 'dv_c19'],
      permiteMoverPara: ['dv_e6', 'dv_e4'],
      permiteCriarCards: false,
      campos: [
        { id: 'dv_c18', nome: 'Link do Pull Request', tipo: 'texto', obrigatorio: false },
        { id: 'dv_c19', nome: 'Revisor', tipo: 'texto', obrigatorio: false },
        { id: 'dv_c20', nome: 'Review aprovado?', tipo: 'lista', obrigatorio: true, opcoes: ['Sim', 'Não'], coresOpcoes: CORES_SIM_NAO },
        { id: 'dv_c21', nome: 'Apontamentos', tipo: 'texto_longo', obrigatorio: false },
      ],
    },
    {
      id: 'dv_e6', nome: 'QA / Homologação',
      tempoMaximoHoras: 48,
      camposVisiveisNoCard: ['dv_c1', 'dv_c23'],
      permiteMoverPara: ['dv_e7', 'dv_e4'],
      permiteCriarCards: false,
      campos: [
        { id: 'dv_c22', nome: 'Testado por', tipo: 'texto', obrigatorio: false },
        { id: 'dv_c23', nome: 'Passou nos testes?', tipo: 'lista', obrigatorio: true, opcoes: ['Sim', 'Não'], coresOpcoes: CORES_SIM_NAO },
        { id: 'dv_c24', nome: 'Bugs Encontrados', tipo: 'texto_longo', obrigatorio: false },
        { id: 'dv_c25', nome: 'Evidência de Teste', tipo: 'anexo', obrigatorio: false },
      ],
    },
    {
      id: 'dv_e7', nome: 'Deploy / Entregue',
      camposVisiveisNoCard: ['dv_c1', 'dv_c27'],
      permiteCriarCards: false,
      campos: [
        { id: 'dv_c26', nome: 'Versão / Release', tipo: 'texto', obrigatorio: false },
        { id: 'dv_c27', nome: 'Data do Deploy', tipo: 'data', obrigatorio: false },
        { id: 'dv_c28', nome: 'Comunicado aos usuários?', tipo: 'lista', obrigatorio: false, opcoes: ['Sim', 'Não'], coresOpcoes: CORES_SIM_NAO },
      ],
    },
    {
      id: 'dv_e8', nome: 'Bloqueado',
      tempoMaximoHoras: 24,
      camposVisiveisNoCard: ['dv_c1', 'dv_c29'],
      permiteMoverPara: ['dv_e4'],
      permiteCriarCards: false,
      campos: [
        { id: 'dv_c29', nome: 'Motivo do Bloqueio', tipo: 'texto_longo', obrigatorio: true },
        { id: 'dv_c30', nome: 'Quem pode desbloquear', tipo: 'texto', obrigatorio: false },
        { id: 'dv_c31', nome: 'Desbloqueado?', tipo: 'lista', obrigatorio: false, opcoes: ['Sim', 'Não'], coresOpcoes: CORES_SIM_NAO },
      ],
    },
  ],
  automacoes: [
    {
      tipo: 'mover',
      nome: 'Item refinado entra na sprint',
      etapaOrigemId: 'dv_e2',
      condicao: { campoId: 'dv_c11', operador: 'igual', valor: 'Sim' },
      etapaDestinoId: 'dv_e3',
    },
    {
      tipo: 'mover',
      nome: 'Bloqueio sinalizado tira o item do desenvolvimento',
      etapaOrigemId: 'dv_e4',
      condicao: { campoId: 'dv_c17', operador: 'igual', valor: 'Sim' },
      etapaDestinoId: 'dv_e8',
    },
    {
      tipo: 'mover',
      nome: 'Review aprovado segue para QA',
      etapaOrigemId: 'dv_e5',
      condicao: { campoId: 'dv_c20', operador: 'igual', valor: 'Sim' },
      etapaDestinoId: 'dv_e6',
      etapaDestinoSenaoId: 'dv_e4',
    },
    {
      tipo: 'mover',
      nome: 'QA aprovado libera o deploy, reprovado volta',
      etapaOrigemId: 'dv_e6',
      condicao: { campoId: 'dv_c23', operador: 'igual', valor: 'Sim' },
      etapaDestinoId: 'dv_e7',
      etapaDestinoSenaoId: 'dv_e4',
    },
    {
      tipo: 'mover',
      nome: 'Desbloqueado volta para desenvolvimento',
      etapaOrigemId: 'dv_e8',
      condicao: { campoId: 'dv_c31', operador: 'igual', valor: 'Sim' },
      etapaDestinoId: 'dv_e4',
    },
  ],
  cards: [
    { id: 'dv_card1', titulo: 'Exportar relatório de vendas em Excel', etapaId: 'dv_e4', etiquetas: ['Feature'], valores: { dv_c1: 'Exportar relatório de vendas em Excel', dv_c3: 'Feature', dv_c4: 'Alta', dv_c8: '5', dv_c14: 60 } },
    { id: 'dv_card2', titulo: 'Erro ao salvar cliente sem telefone', etapaId: 'dv_e5', etiquetas: ['Bug'], valores: { dv_c1: 'Erro ao salvar cliente sem telefone', dv_c3: 'Bug', dv_c4: 'Urgente', dv_c8: '2' } },
    { id: 'dv_card3', titulo: 'Migrar autenticação para OAuth', etapaId: 'dv_e2', etiquetas: ['Débito técnico'], valores: { dv_c1: 'Migrar autenticação para OAuth', dv_c3: 'Débito técnico', dv_c4: 'Média', dv_c8: '13' } },
    { id: 'dv_card4', titulo: 'Filtro por período no dashboard', etapaId: 'dv_e6', etiquetas: ['Feature'], valores: { dv_c1: 'Filtro por período no dashboard', dv_c3: 'Feature', dv_c4: 'Média', dv_c8: '3' } },
    { id: 'dv_card5', titulo: 'Integração com gateway de pagamento', etapaId: 'dv_e8', etiquetas: ['Bloqueado'], valores: { dv_c1: 'Integração com gateway de pagamento', dv_c3: 'Feature', dv_c4: 'Alta', dv_c8: '8', dv_c29: 'Aguardando credenciais de homologação do fornecedor.' } },
    { id: 'dv_card6', titulo: 'Notificação push no app', etapaId: 'dv_e1', etiquetas: ['Feature'], valores: { dv_c1: 'Notificação push no app', dv_c3: 'Feature', dv_c4: 'Baixa' } },
    { id: 'dv_card7', titulo: 'Correção de layout no mobile', etapaId: 'dv_e7', valores: { dv_c1: 'Correção de layout no mobile', dv_c3: 'Bug', dv_c4: 'Média', dv_c8: '2', dv_c26: 'v2.14.0' } },
  ],
  tour: [
    '⌨️ Board de squad: do backlog ao deploy, com QA e review no caminho.',
    '1️⃣ "Backlog": ideia registrada com tipo, prioridade e valor de negócio.',
    '2️⃣ "Refinamento": critérios de aceite e estimativa em pontos. Refinado? entra na sprint sozinho.',
    '3️⃣ "Sprint - A Fazer" → "Em Desenvolvimento" com barra de progresso.',
    '4️⃣ "Code Review": reprovado volta para o dev automaticamente.',
    '5️⃣ "QA": passou → deploy. Não passou → volta para desenvolvimento com os bugs listados.',
    '🚧 Marcou "bloqueado"? o card sai da fila e vai para a coluna Bloqueado — WIP limpo.',
    '⏱️ SLA de 24h em Code Review e Bloqueado: PR parado e impedimento aparecem no Dashboard.',
  ],
  etapasDicas: [
    { quemFaz: 'PO / Solicitante', objetivo: 'Registrar a demanda com o problema, não com a solução pronta.', ondeConfigurar: 'Configuração da Etapa > Campos' },
    { quemFaz: 'PO + Time técnico', objetivo: 'Definir critérios de aceite e estimar — sem isso, sprint vira aposta.', automacoes: ['Já configurado: item refinado entra na sprint'], ondeConfigurar: 'Automações > "Item refinado entra na sprint"' },
    { quemFaz: 'Time', objetivo: 'Fila da sprint atual, já com dono definido.', ondeConfigurar: 'Configuração da Etapa > Campos' },
    { quemFaz: 'Desenvolvedor', objetivo: 'Construir com progresso visível — reunião diária fica mais curta.', automacoes: ['Já configurado: marcar bloqueio move para a coluna Bloqueado'], ondeConfigurar: 'Automações > "Bloqueio sinalizado tira o item do desenvolvimento"' },
    { quemFaz: 'Outro desenvolvedor', objetivo: 'Revisar código antes de virar problema em produção.', automacoes: ['Já configurado: reprovado volta para desenvolvimento'], ondeConfigurar: 'Automações > "Review aprovado segue para QA"' },
    { quemFaz: 'QA / PO', objetivo: 'Validar contra os critérios de aceite com evidência anexada.', automacoes: ['Já configurado: reprovado no QA volta para o dev'], ondeConfigurar: 'Automações > "QA aprovado libera o deploy, reprovado volta"' },
    { quemFaz: 'DevOps / Dev', objetivo: 'Publicar e comunicar quem usa — entrega só termina quando o usuário sabe.', conexoes: ['Ligue ao Service Desk para fechar os chamados que essa entrega resolve'], ondeConfigurar: 'Conexões entre Fluxos > Service Desk' },
    { quemFaz: 'Time / Gestor', objetivo: 'Tornar impedimento visível — o que fica aqui custa dinheiro todo dia.', automacoes: ['Já configurado: desbloqueado volta para desenvolvimento'], ondeConfigurar: 'Automações > "Desbloqueado volta para desenvolvimento"' },
  ],
};

export const TEMPLATES_TI: DefaultTemplate[] = [
  serviceDesk,
  gestaoAcessos,
  desenvolvimento,
];
